import {
    Tooltip as MaterialTooltip,
} from '@mui/material'

import useStyles from './Tooltip.style'
import TooltipPlacement from './Tooltip.types'

type Props = {
    title: string | JSX.Element,
    enterDelay?: number,
    disabled?: boolean,
    placement?: TooltipPlacement,
    children: JSX.Element,
    arrow?: boolean,
    followCursor?: boolean,
}

const defaultProps: Partial<Props> = {
    enterDelay: 0,
    disabled: false,
    placement: 'bottom',
    arrow: true,
    followCursor: false,
}

const Tooltip = ({
    title,
    disabled,
    children,
    placement,
    enterDelay,
    followCursor,
    arrow,

}: Props) => {
    const {
        classes,
    } = useStyles()
    const isContent = typeof title !== 'string'

    return (
        <MaterialTooltip
            arrow={arrow}
            enterDelay={enterDelay}
            placement={placement}
            title={title}
            disableHoverListener={disabled}
            disableFocusListener={disabled}
            disableTouchListener={disabled}
            followCursor={followCursor}
            classes={{
                tooltip: isContent ? classes.tooltipWithContent : classes.tooltip,
                arrow: isContent ? classes.arrowWithContent : classes.arrow,
            }}
            data-testid="mui-tooltip"
        >
            {children}
        </MaterialTooltip>
    )
}

Tooltip.defaultProps = defaultProps

export default Tooltip
